<!--
    描述：人员管理--人员列表
    时间：2020-04-23
    Created by zwh
-->
<template>
	<!--
    <div class="h100">
        <div class="w-table-layout" style="border-top:1px solid #eee">
            <div class="w-table-content tree-content" ref="btnContent">
                <el-tree ref="btnTree"
                    :height="tableObj.tableH"
                    :data="tableObj.tableData"
                    :props="defaultProps"
                    :expand-on-click-node="false"
                    :highlight-current="true"
                    default-expand-all
                    show-checkbox
                    :check-strictly="true"
                    node-key="id"
                    :default-checked-keys="treeDefaultCheckedKey""
                ></el-tree>
            </div>
        </div>
    </div>
    -->
	<div class="h100">
		<div class="w-page-main">
			<div class="w-page-header superiors-search-area">
				<div class="left-text overflow-hidden">
					<span><b>按钮列表</b></span>
				</div>
				<div class="btnGroups">
					<el-button type="success"
							   size="small"
							   icon="el-icon-check"
							   v-if="roleBtns.includes('btn_permission_save')"
							   @click="saveClick()">保存</el-button>
				</div>
			</div>
			<div class="w-page-container pdb10">
				<div class="w-table-layout">
					<div class="w-table-content"
						 ref="btnContent"
						 style=" overflow-y: auto; border:1px solid #eee">
						<el-tree ref="btnTree"
								 :height="tableObj.tableH"
								 :data="tableObj.tableData"
								 :props="defaultProps"
								 :expand-on-click-node="false"
								 :highlight-current="true"
								 default-expand-all
								 show-checkbox
								 :check-strictly="true"
								 node-key="id"
								 :default-checked-keys="treeDefaultCheckedKey"></el-tree>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import { getBtnsByRoleIdMenuId } from 'api/system/menuBtn.js'
import { saveOrUpdateRoleMenuBtn } from 'api/system/role.js'
import { getLimitBtnByLimitIdMore } from 'api/system/limitRole.js'
export default {
	components: {},
	data() {
		return {
			transObj: {
				roleId: '',
				menuId: '',
				menuName: '',
				mode: ''
			},

			btnLoading: false,
			dialogObj: {
				title: '',
				visible: false,
				width: '650px',
				mode: 'add'
			},
			tableObj: {
				loading: false,
				tableH: 400,
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				pageList: [10, 20, 50, 100] // 显示条数数组
			},
			defaultProps: {
				children: 'children',
				label: 'btnName'
			},
			treeDefaultCheckedKey: [],

		}
	},
	methods: {
		initMenuBtnInfo(obj) {
		    /*
		    if(limitObj != '')
		    this.limitRoleBtnShow = typeof(limitObj.limitRoleIdList.find(roleId=> {return roleId==obj.roleId })) != 'undefined' ? true : false
            */

			//赋值菜单信息
			this.transObj = obj

            //查询按钮信息
            this.getMenuBtnTableList()

            /*
			let limitId = '1374620986950475778'//
            if(limitId != '') {
                this.getLimitBtnByLimitIdMore(limitId, obj)
            }else {

            }
            */
		},
		getMenuBtnTableList() {
			let that = this
			let param = {
				roleId: this.transObj.roleId,
				menuId: this.transObj.menuId
			}

			that.treeDefaultCheckedKey = []
			getBtnsByRoleIdMenuId(param).then(res => {
				if (res.operationCode == 1) {
				    let data = res.data.sysBtnList
					that.tableObj.tableData = data
					that.treeDefaultCheckedKey = res.data.checkBtnIdList.concat()

					//数据限制
                    that.getLimitBtnByLimitIdMore()
				}
			})
		},
        getLimitBtnByLimitIdMore(){
            let that = this

            let limitId = ''//
            if(limitId == '') return

            let param = {
                limitId : limitId,
                roleId : this.transObj.roleId,
                menuId: this.transObj.menuId
            }
            getLimitBtnByLimitIdMore(param).then(res => {
                if (res.operationCode == 1) {
                    let limitBtnIdList = res.data.limitBtnIdList.concat()
                    /*
                    that.tableObj.tableData = that.tableObj.tableData.map(prop=>{
                        let disabled = typeof(limitBtnIdList.find(BtnId=> {return BtnId==prop.id })) != 'undefined' ? false : true
                        return {...prop, disabled : disabled}
                    })
                    */
                }
            });
        },

		//新增、修改、删除等操作按钮点击事件
		doClick(obj, type) {
			this.dialogObj.mode = type
			if (type === 'add') {
				this.transObj.id = ''
				this.dialogObj.title = '新增按钮'
				this.dialogObj.visible = true
			} else if (type === 'edit') {
				this.transObj.id = obj.id
				this.dialogObj.title = '编辑按钮'
				this.dialogObj.visible = true
			} else if (type === 'delete') {
				this.delete(obj)
			}
		},
		delete(obj) {
			let that = this
			this.$confirm('确认删除吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let param = { id: obj.id }
				deleteById(param).then(res => {
					if (res.operationCode == 1) {
						that.$message({ message: '删除成功', type: 'success' })
						that.getMenuBtnTableList()
					} else {
						that.$message({ message: res.msg, type: 'error' })
					}
				})
			})
		},
		// 关闭弹窗事件
		handleClose() {
			this.dialogObj.visible = false
		},
		// 确定按钮事件
		saveClick() {
			let that = this

			if (that.transObj.roleId == '') {
				that.$message({ message: '请选择角色信息', type: 'warning' })
				return
			}
			if (that.transObj.menuId == '') {
				that.$message({ message: '请选择菜单信息', type: 'warning' })
				return
			}
			let idsSelection = this.$refs.btnTree.getCheckedKeys().concat()
			let param = {
				roleId: that.transObj.roleId,
				menuId: that.transObj.menuId,
				btnIdsSelection: idsSelection
			}
			saveOrUpdateRoleMenuBtn(param).then(res => {
				if (res.operationCode == 1) {
					that.$message({ message: '保存成功', type: 'success' })
				}
			})
		},
		// 切换显示条数
		handleSizeChange(val) {},
		// 切换当前页码
		handleCurrentChange(cur) {},
		handleSuccess() {
			this.dialogObj.visible = false
			this.getMenuBtnTableList()
		}
	},
	mounted() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.tableObj.tableH = this.$refs.btnContent.offsetHeight
			}, 100)
		})
	},
	// 缓存页面进入时
	activated() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.tableObj.tableH = this.$refs.btnContent.offsetHeight
			}, 100)
		})
	},
	computed: {
		...mapState('app', { clientSize: state => state.clientSize }),
		...mapState('menu', {
			roleBtns: state => state.roleBtns
		})
	},
	watch: {
		clientSize(val) {
			this.tableObj.tableH = this.$refs.btnContent.offsetHeight
		}
	}
}
</script>
<style lang="less" scoped>
.tree-content {
	overflow-y: auto;
	padding: 5px 0px;
}
.w-table-page {
	padding-bottom: 5px;
}
</style>
